import { render, staticRenderFns } from "./Java.vue?vue&type=template&id=3272e7df&scoped=true&"
import script from "./Java.vue?vue&type=script&lang=js&"
export * from "./Java.vue?vue&type=script&lang=js&"
import style0 from "./Java.vue?vue&type=style&index=0&id=3272e7df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3272e7df",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCard,VCardTitle,VSheet})
